import { defaultEnv } from "./default";

export const environment = {
    ...defaultEnv,
    api: 'https://betaapi.leadadvantagepro.com/api/',
    authClient: 'https://betaauthorize.leadadvantagepro.com/',
    isProduction: false,
}